import { ReactComponent as SwitchIcon } from 'assets/images/SwitchIcon.svg'
import { SwitchIconContainer } from './Styles'

interface Props {
  handleClick: () => void
}

const SwitchButton = ({ handleClick }: Props) => {
  return (
    <SwitchIconContainer onClick={handleClick}>
      <SwitchIcon />
    </SwitchIconContainer>
  )
}

export default SwitchButton
